import actionTypes from "_constants/actionTypes";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_COUNTRIES_DATA:
      return {
        ...state,
        countriesData: action.payload,
        countriesDataError: null,
      };
    case actionTypes.GET_COUNTRIES_ERROR:
      return {
        ...state,
        countriesData: null,
        countriesDataError: action.payload,
      };

    case actionTypes.GET_PROVINCES_DATA:
      return {
        ...state,
        provincesData: action.payload,
        provincesDataError: null,
      };
    case actionTypes.GET_PROVINCES_ERROR:
      return {
        ...state,
        provincesData: null,
        provincesDataError: action.payload,
      };

    case actionTypes.GET_CITIES_DATA:
      return {
        ...state,
        citiesData: action.payload,
        citiesDataError: null,
      };
    case actionTypes.GET_CITIES_ERROR:
      return {
        ...state,
        citiesData: null,
        citiesDataError: action.payload,
      };

      case actionTypes.GET_COURSES_DATA:
        return {
          ...state,
          coursesData: action.payload,
          coursesDataError: null,
        };
        
      case actionTypes.GET_PROFESSIONS_DATA:
        return {
          ...state,
          professionsData: action.payload,
          professionsDataError: null,
        };
      case actionTypes.GET_PROFESSIONS_ERROR:
        return {
          ...state,
          professionsData: null,
          professionsDataError: action.payload,
        };
    default:
      return state;
  }
};
